var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('p',[_vm._v(" "+_vm._s(_vm.$t("attribution.sponsorblock-text"))+" "),_c('a',{attrs:{"href":"https://sponsor.ajay.app"}},[_vm._v("https://sponsor.ajay.app")])])])}
var staticRenderFns = []

export { render, staticRenderFns }